import Vue from 'vue'
import App from './App'
import router from './router/index.js'

Vue.config.productionTip = false

import store from './store'

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

// import axios from "./utils/http.js";
import axios from "axios";
Vue.prototype.$axios = axios;
axios.defaults.baseURL = window.PLATFROM_CONFIG.baseUrl;

import './utils/rem.js'

import global_ from './components/global'//引用文件
Vue.prototype.GLOBAL = global_//挂载到Vue实例上面




// import aMap from 'vue-amap'

// Vue.use(aMap)

// aMap.initAMapApiLoader({
//   key: 'b9783f54fd02810327281500a6f45570',
//   plugin: ['AMap.Geolocation', 'AMap.Geocoder']
// })

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})







// WEBPACK FOOTER //
// ./src/main.js